__turbopack_context__.v({
  "cardBox": "tnpsc-group-II-mains-test-series-module__unTR6q__cardBox",
  "cardTop": "tnpsc-group-II-mains-test-series-module__unTR6q__cardTop",
  "chooseCard": "tnpsc-group-II-mains-test-series-module__unTR6q__chooseCard",
  "csatborder": "tnpsc-group-II-mains-test-series-module__unTR6q__csatborder",
  "featureCard1": "tnpsc-group-II-mains-test-series-module__unTR6q__featureCard1",
  "featureSection": "tnpsc-group-II-mains-test-series-module__unTR6q__featureSection",
  "featureTitle": "tnpsc-group-II-mains-test-series-module__unTR6q__featureTitle",
  "heading3d": "tnpsc-group-II-mains-test-series-module__unTR6q__heading3d",
  "highlightCard": "tnpsc-group-II-mains-test-series-module__unTR6q__highlightCard",
  "icon": "tnpsc-group-II-mains-test-series-module__unTR6q__icon",
  "iconCircle": "tnpsc-group-II-mains-test-series-module__unTR6q__iconCircle",
  "iconPulse": "tnpsc-group-II-mains-test-series-module__unTR6q__iconPulse",
  "iconWrapper": "tnpsc-group-II-mains-test-series-module__unTR6q__iconWrapper",
  "item": "tnpsc-group-II-mains-test-series-module__unTR6q__item",
  "normalbutton": "tnpsc-group-II-mains-test-series-module__unTR6q__normalbutton",
  "normalbutton1": "tnpsc-group-II-mains-test-series-module__unTR6q__normalbutton1",
  "pagemaintitle": "tnpsc-group-II-mains-test-series-module__unTR6q__pagemaintitle",
  "paybill": "tnpsc-group-II-mains-test-series-module__unTR6q__paybill",
  "premiumCard": "tnpsc-group-II-mains-test-series-module__unTR6q__premiumCard",
  "priceBox": "tnpsc-group-II-mains-test-series-module__unTR6q__priceBox",
  "primaryBtn": "tnpsc-group-II-mains-test-series-module__unTR6q__primaryBtn",
  "ribbon": "tnpsc-group-II-mains-test-series-module__unTR6q__ribbon",
  "scheduleItem": "tnpsc-group-II-mains-test-series-module__unTR6q__scheduleItem",
  "scheduleSection": "tnpsc-group-II-mains-test-series-module__unTR6q__scheduleSection",
  "sectionDesc": "tnpsc-group-II-mains-test-series-module__unTR6q__sectionDesc",
  "sectionTitle": "tnpsc-group-II-mains-test-series-module__unTR6q__sectionTitle",
  "sectionredtitle": "tnpsc-group-II-mains-test-series-module__unTR6q__sectionredtitle",
  "sectiontitle": "tnpsc-group-II-mains-test-series-module__unTR6q__sectiontitle",
  "tableheading": "tnpsc-group-II-mains-test-series-module__unTR6q__tableheading",
  "tableheading1": "tnpsc-group-II-mains-test-series-module__unTR6q__tableheading1",
  "tablepara": "tnpsc-group-II-mains-test-series-module__unTR6q__tablepara",
  "tablescroll": "tnpsc-group-II-mains-test-series-module__unTR6q__tablescroll",
  "whySection": "tnpsc-group-II-mains-test-series-module__unTR6q__whySection",
  "whysia": "tnpsc-group-II-mains-test-series-module__unTR6q__whysia",
});
